import React, { Component } from 'react';
import Layout from '../layout/Main';
import Recognition from '../components/Requirement/Recognition';
import Navigation from '../components/Requirement/Navigation';
import Registered from '../components/Requirement/Registered';
import Certified from '../components/Requirement/Certified';
import Hitched from '../components/Requirement/Hitched';

export default class Requirement extends Component {
  state = {
    activePage: 'hitched'
  }

  handleOnClick = (activePage) => {
    this.setState({activePage})
  }

  renderPage = () => {
    if (this.state.activePage === 'registered') return (<Registered/>)
    if (this.state.activePage === 'certified') return (<Certified/>)
    if (this.state.activePage === 'hitched') return (<Hitched/>)
  }

  render() {
    return (
      <Layout>
        <Recognition/>
        <section className="syarat-psre">
          <div className="container">
            {/* <Navigation handleOnClick={this.handleOnClick} activePage={this.state.activePage}/> */}
            <div className="tab-content" id="pills-tabContent-syarat-psre">
              {this.renderPage()}
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}
